import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

export type SectionGridProps = React.PropsWithChildren<{
    title: string;
    icon?: React.ReactNode;
    gridXs?: number;
    gridSm?: number;
}>;

export const SectionGrid = ({ title, icon, children, gridXs = 11, gridSm = 11 }: SectionGridProps) => {
    return (
        <Grid item xs={gridXs} sm={gridSm}>
            <Paper
                elevation={0}
                sx={{
                    mb: 3,
                    border: '1px solid #e0e0e0',
                    borderRadius: 2,
                }}
            >
                <Box
                    sx={{
                        px: 3,
                        py: 2,
                        borderBottom: '1px solid #e0e0e0',
                        bgcolor: '#e3f2fd',
                        borderTopLeftRadius: 2,
                        borderTopRightRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                    }}
                >
                    <Box sx={{ color: 'primary.main', display: 'flex' }}>{icon}</Box>
                    <Typography variant="subtitle1" fontWeight="bold" color="text.primary">
                        {title}
                    </Typography>
                </Box>
                <Box sx={{ p: 3 }}>{children}</Box>
            </Paper>
        </Grid>
    );
}
